import type { Theme } from './types';

export const corporateTheme: Theme = {
  id: 'corporate',
  name: 'Korporacyjny',
  description: 'Profesjonalny granatowy motyw',
  preview: {
    primary: '#f0f4f8',
    secondary: '#1e3a5f',
    accent: '#0ea5e9',
  },
  colors: {
    bgPrimary: '#f0f4f8',
    bgSecondary: '#ffffff',
    bgTertiary: '#e2e8f0',
    bgAccent: '#cbd5e1',

    sidebarBg: '#1e3a5f',
    sidebarText: '#94a3b8',
    sidebarHover: '#2d4a6f',
    sidebarActive: '#0ea5e9',

    headerBg: '#1e3a5f',
    headerGradient: 'linear-gradient(135deg, #1e3a5f 0%, #2d4a6f 50%, #0c4a6e 100%)',
    headerText: '#ffffff',

    textPrimary: '#1e293b',
    textSecondary: '#475569',
    textMuted: '#94a3b8',
    textInverse: '#ffffff',

    borderPrimary: '#cbd5e1',
    borderSecondary: '#94a3b8',
    borderAccent: '#0ea5e9',

    accentPrimary: '#0ea5e9',
    accentHover: '#0284c7',
    accentLight: '#e0f2fe',

    success: '#10b981',
    successLight: '#d1fae5',
    warning: '#f59e0b',
    warningLight: '#fef3c7',
    error: '#ef4444',
    errorLight: '#fee2e2',
    info: '#0ea5e9',
    infoLight: '#e0f2fe',

    shadow: '0 1px 3px rgba(0,0,0,0.12)',
    shadowLg: '0 10px 15px -3px rgba(0,0,0,0.15)',
    overlay: 'rgba(30, 58, 95, 0.6)',

    scrollbarTrack: '#e2e8f0',
    scrollbarThumb: '#94a3b8',
    scrollbarThumbHover: '#64748b',

    inputBg: '#ffffff',
    inputText: '#1e293b',
  },
};
